import React from "react";
import formatAsCurrency from "@wss/utilities/formatAsCurrency";
import LoginLink from "../LoginLink";
import { Product } from "~/common/Store/models/ProductListing";

interface Props {
  price: Product["price"];
  mapPrice: number;
  overSizedPriceStyle?: string;
}

const MapOverrideEnabled = ({
  price,
  mapPrice,
  overSizedPriceStyle,
}: Props) => (
  <>
    <LoginLink className="map__text no-underline">
      <p className="text__discount">
        <span className="text__highlight">
          {formatAsCurrency.formatIfUndefined(price.price - mapPrice)}
        </span>
        {" lower"}
      </p>
      <p className="text__description font-normal">
        <>
          <span className="text__link underline">Login</span>
          {" or "}
          <strong>add to cart</strong>
        </>
        {" to see our "}
        <span className="text__highlight">price!</span>
      </p>
    </LoginLink>

    <div className="map__price">
      <label className="price__label">Retail Price </label>
      <p className={`price ${overSizedPriceStyle}`}>
        {formatAsCurrency.formatIfUndefined(price.price)}
      </p>
    </div>
  </>
);

export default MapOverrideEnabled;
